var __jsx = React.createElement;
import React, { useState, useRef, useEffect } from "react";
import { faChevronDown, faChevronUp, faXmark } from "@fortawesome/pro-regular-svg-icons";
import AwesomeIcon from "../../AwesomeIcon";
import { useDropdownScroll } from "../hooks/useDropdownScroll";
import CustomValueInput from "./CustomValueInput";
import classNames from "classnames";
import { getInputBorderAndBackgroundClasses } from "../../../utils/fieldValidation";
var SelectInput = function SelectInput(_ref) {
  var value = _ref.value,
    placeholder = _ref.placeholder,
    options = _ref.options,
    _onChange = _ref.onChange,
    onOpenChange = _ref.onOpenChange,
    disabled = _ref.disabled,
    isEmpty = _ref.isEmpty,
    isRequired = _ref.isRequired,
    errorMessage = _ref.errorMessage,
    allowCustomValue = _ref.allowCustomValue,
    pattern = _ref.pattern,
    formatHint = _ref.formatHint,
    maxLength = _ref.maxLength,
    isShouldBeBlankError = _ref.isShouldBeBlankError;
  var _useState = useState(false),
    isOpen = _useState[0],
    setIsOpen = _useState[1];
  var containerRef = useRef(null);
  var shouldShowServerError = !isEmpty && !!errorMessage;
  var borderAndBackgroundClasses = getInputBorderAndBackgroundClasses(shouldShowServerError, isRequired !== null && isRequired !== void 0 ? isRequired : false, isEmpty !== null && isEmpty !== void 0 ? isEmpty : false);
  var toggleOpen = function toggleOpen(open) {
    if (disabled) return;
    setIsOpen(open);
    onOpenChange === null || onOpenChange === void 0 || onOpenChange(open);
  };

  // Close dropdown when clicking outside
  useEffect(function () {
    var handleClickOutside = function handleClickOutside(event) {
      if (containerRef.current && !containerRef.current.contains(event.target)) {
        toggleOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return function () {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // Use custom hook to handle dropdown scrolling
  useDropdownScroll(isOpen, containerRef);
  var handleSelectOption = function handleSelectOption(optionValue) {
    _onChange(optionValue);
    toggleOpen(false);
  };
  var handleClear = function handleClear(e) {
    e.preventDefault();
    e.stopPropagation();
    _onChange(null);
  };

  // Find the label for the current value
  var selectedOption = options.find(function (opt) {
    return String(opt.value) === String(value);
  });
  var isCustomValue = value && !selectedOption && allowCustomValue;
  var displayValue = selectedOption ? selectedOption.label : isCustomValue ? "Other - ".concat(value) : value && !selectedOption ? value : placeholder;
  return /*#__PURE__*/React.createElement("div", {
    className: "relative w-full",
    ref: containerRef
  }, /*#__PURE__*/React.createElement("div", {
    onClick: function onClick() {
      return toggleOpen(!isOpen);
    },
    className: classNames("w-full h-[40px] px-4 py-3 border rounded-lg bg-white dark:bg-gray-900 text-gray-900 dark:text-white flex justify-between items-center", {
      "opacity-60 cursor-not-allowed": disabled,
      "cursor-pointer": !disabled,
      "ring-1 ring-teal-500 dark:ring-teal-400 border border-teal-500 dark:border-teal-400": isOpen
    }, !isOpen && borderAndBackgroundClasses)
  }, /*#__PURE__*/React.createElement("span", {
    className: classNames("truncate flex-1 mr-2 text-left", {
      "text-gray-500 dark:text-gray-400": !value
    })
  }, displayValue), /*#__PURE__*/React.createElement("div", {
    className: "flex items-center gap-2"
  }, value && !disabled && /*#__PURE__*/React.createElement("button", {
    type: "button",
    onClick: handleClear,
    className: "flex items-center text-gray-500 dark:text-gray-400 hover:text-gray-600 dark:hover:text-gray-500 focus:outline-none",
    "aria-label": "Clear selection"
  }, /*#__PURE__*/React.createElement(AwesomeIcon, {
    name: faXmark,
    size: "sm"
  })), /*#__PURE__*/React.createElement(AwesomeIcon, {
    name: isOpen ? faChevronUp : faChevronDown,
    className: "h-4 text-gray-500 dark:text-gray-400"
  }))), isOpen && /*#__PURE__*/React.createElement("div", {
    className: "absolute z-10 w-full mt-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 shadow-lg max-h-60 overflow-y-auto"
  }, /*#__PURE__*/React.createElement("div", {
    onClick: function onClick() {
      return handleSelectOption(null);
    },
    className: "px-4 py-3 hover:bg-gray-100 dark:hover:bg-gray-600 cursor-pointer transition-colors text-left border-b border-gray-300 dark:border-gray-600 ".concat(!value ? "bg-gray-100 dark:bg-gray-600" : "")
  }, /*#__PURE__*/React.createElement("span", {
    className: "text-[14px] text-gray-500 dark:text-gray-400 italic"
  }, "None")), options.map(function (option) {
    var isSelected = String(value) === String(option.value);
    return /*#__PURE__*/React.createElement("div", {
      key: option.value,
      onClick: function onClick() {
        return handleSelectOption(option.value);
      },
      className: "px-4 py-3 hover:bg-gray-100 dark:hover:bg-gray-600 cursor-pointer transition-colors text-left ".concat(isSelected ? "bg-gray-100 dark:bg-gray-600" : "")
    }, /*#__PURE__*/React.createElement("span", {
      className: "text-[14px] text-gray-900 dark:text-white"
    }, option.label));
  }), allowCustomValue && /*#__PURE__*/React.createElement(CustomValueInput, {
    onChange: function onChange(customValue) {
      _onChange(customValue);
    },
    onClose: function onClose() {
      return toggleOpen(false);
    },
    pattern: pattern,
    formatHint: formatHint,
    maxLength: maxLength
  })), shouldShowServerError && /*#__PURE__*/React.createElement("div", {
    className: "mt-1 ml-2 text-left text-red-500 dark:text-red-400 text-sm"
  }, errorMessage));
};
export default SelectInput;